import {tokens} from '@pleo-io/telescope'
import styled, {css} from 'styled-components'

import Image from '@helios/shared/components/image'
import {Section} from '@helios/shared/styles/grid'
import {colors, fonts} from '@helios/shared/theme'
import mq from '@helios/shared/utils/media-query'

import {Props} from './title-with-icon-grid'

type WrapperProps = Pick<Props, 'highlightColor'>

export const Wrapper = styled(Section)<WrapperProps>`
    strong {
        font-weight: ${fonts.weights.normal};
        background: ${(props) =>
            props.highlightColor ? colors.background[props.highlightColor] : 'inherit'};
    }
`

export const ContentWrapper = styled.div`
    display: grid;
    align-content: center;
    gap: ${tokens.spacing20};
    justify-items: stretch;

    ${mq.min('xs')} {
        gap: ${tokens.spacing32};
        justify-items: start;
    }
`

interface IconsProps {
    $twoCol?: boolean
}

const twoColStyles = css`
    ${mq.between('md', 'lg')} {
        grid-template-columns: repeat(2, auto);
        justify-content: space-evenly;
    }
`

export const Icons = styled.div<IconsProps>`
    display: grid;
    grid-template-columns: repeat(2, auto);
    justify-content: space-between;

    ${mq.min('xs')} {
        gap: ${tokens.spacing8};
        grid-template-columns: repeat(4, auto);
    }

    ${mq.min('sm')} {
        grid-template-columns: repeat(2, auto);
    }

    ${mq.min('md')} {
        grid-template-columns: repeat(3, auto);
    }

    ${mq.min('lg')} {
        grid-template-columns: repeat(4, auto);
    }

    ${(props) => props.$twoCol && twoColStyles}
`

export const IconWrapper = styled.div`
    display: grid;
    justify-items: center;
    gap: ${tokens.spacing8};
    padding: ${tokens.spacing20} ${tokens.spacing28};

    :nth-child(n + 9) {
        ${mq.max('md')} {
            display: none;
        }
    }
`

export const Icon = styled(Image)`
    width: 100px;
    height: 60px;
    object-fit: contain;
`
